export const languageProvider = {
	en: {
		uploadLabel: 'Upload',
		chooseLabel: 'Select file',
		chooseManyLabel: 'Select files',
		chooseManyLabelAuto: 'Select files and upload', 
		cancelLabel: 'Delete all',
		dragdropArea: 'Drag and drop files',
		dragdropAreaAuto: 'Drag and drop files and upload',
	},
};
